module.exports = __webpack_public_path__ + "static/media/icon-sair.f95ea3f6.svg";